import { IVtoFeature } from '~interfaces/IVto';

export const hasVtoFoundationFeature = (vtoFeature?: IVtoFeature) => {
    return vtoFeature && vtoFeature.foundation;
};
export const hasSaveMatch = (vtoFeature?: IVtoFeature) => {
    const vtoFoundationFeature = hasVtoFoundationFeature(vtoFeature);

    return !!(vtoFoundationFeature && vtoFoundationFeature.isSaveMatchEnabled);
};
export const hasPairProduct = (isPairShadesTabActive: boolean, vtoFeature?: IVtoFeature) => {
    const vtoFoundationFeature = hasVtoFoundationFeature(vtoFeature);

    return !!(vtoFoundationFeature && vtoFoundationFeature.hasLipVto && isPairShadesTabActive);
};
